import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Switch from "@material-ui/core/Switch";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CreateIcon from "@material-ui/icons/Create";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import Divider from "@material-ui/core/Divider";
import Loader from "../../components/Loader";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { EQUIPMENT_TYPE } from "../../configs/urls";
import { getApi, postApi, putApi } from "../../services/api";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "80%",
    margin: "auto",
  },
  box: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
}));

export default function ManageEquipmentTypes() {
  const classes = useStyles();
  const [equipmentTypes, setEquipmentTypeList] = useState([]);
  const [isRequesting, setIsRequestig] = useState(false);
  const [params, setParams] = useState({ page: 0 });
  const [isDialogBoxOpen, setIsDialogBoxOpen] = useState(false);
  const [dialogBoxActionName, setDialogBoxActionName] = useState("ADD");
  const [equipmentTypeName, setEquipmentTypeName] = useState("");
  const [
    currentSelectedEquipmentType,
    setCurrentSelectedEquipmentType,
  ] = useState("");

  const handleDialogBoxClickOpen = (action, equipmentType) => {
    setDialogBoxActionName(action);

    if (equipmentType && equipmentType.name) {
      setCurrentSelectedEquipmentType(equipmentType);
      setEquipmentTypeName(equipmentType.name);
    }
    setIsDialogBoxOpen(true);
  };

  const handleDialogBoxClose = (action, equipmentIndex) => {
    if (action === "add") {
      setIsRequestig(true);
      const params = {
        name: equipmentTypeName,
      };

      const equipmentTypeReq =
        dialogBoxActionName === "ADD"
          ? postApi(EQUIPMENT_TYPE, params)
          : putApi(EQUIPMENT_TYPE, {
              ...params,
              id: currentSelectedEquipmentType.id,
            });

      equipmentTypeReq
        .then(
          (res) => {
            setIsDialogBoxOpen(false);
            setEquipmentTypeName("");
            if (dialogBoxActionName === "ADD") {
              const data = equipmentTypes;
              data.push({
                ...res.data,
                active: 1,
                fixed: 0,
              });
              setEquipmentTypeList(data);
            } else {
              const idx = equipmentTypes.findIndex((equipment) => {
                return equipment.id == currentSelectedEquipmentType.id;
              });
              const data = equipmentTypes;
              data[idx].name = equipmentTypeName;
              setEquipmentTypeList(data);
              setCurrentSelectedEquipmentType("");
            }
          },
          (err) => {
            console.log(err);
          }
        )
        .finally(() => {
          setIsRequestig(false);
        });
    } else {
      setIsDialogBoxOpen(false);
      setEquipmentTypeName("");
      setCurrentSelectedEquipmentType("");
    }
  };

  useEffect(() => {
    fetchEquipmentTypes(true);
  }, []); //eslint-disable-line

  const fetchEquipmentTypes = (isInitialLoad) => {
    setIsRequestig(true);

    getApi(EQUIPMENT_TYPE, params)
      .then(
        (res) => {
          // if (isInitialLoad) setTotalequipmentCount(res.meta.total);

          const data = res.data || [];
          const newList = [...equipmentTypes, ...data];
          setEquipmentTypeList(newList);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const changeEquipmentTypeStatus = (equipment, idx) => {
    setIsRequestig(true);
    const params = {
      active: equipment.active == 0 ? "1" : "0",
      id: equipment.id,
    };
    putApi(EQUIPMENT_TYPE, params)
      .then(
        (res) => {
          const data = equipmentTypes;
          data[idx].active = params.active;
          setEquipmentTypeList(data);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <Grid item xs={12} md={12}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h6" className={classes.title}>
            Manage Equipment types
          </Typography>
          <Button
            variant="contained"
            onClick={() => handleDialogBoxClickOpen("ADD")}
            color="primary"
            className={classes.button}
            endIcon={<Icon>add_circle</Icon>}
          >
            Add Equipment Type
          </Button>
        </Grid>
        <div className={classes.box}>
          <List>
            {equipmentTypes.map((data, idx) => (
              <div key={idx}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <DriveEtaIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={data.name} />
                  {data.fixed == 0 ? (
                    <ListItemSecondaryAction>
                      {/* <IconButton edge="end" aria-label="edit" onClick={() => handleDialogBoxClickOpen("UPDTAE", data)}>
                      <CreateIcon />
                    </IconButton> */}
                      {/* <Switch
                                        checked={data.active == 1}
                                        onChange={() => { changeEquipmentTypeStatus(data, idx) }}
                                        color="primary"
                                        name="checkedB"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                      /> */}
                    </ListItemSecondaryAction>
                  ) : null}
                </ListItem>
                {idx !== 6 ? <Divider /> : null}
              </div>
            ))}
          </List>
        </div>
      </Grid>
      <Dialog
        open={isDialogBoxOpen}
        onClose={handleDialogBoxClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add Equipment Type</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="equipmentType"
            label="Equipment Type"
            value={equipmentTypeName || ""}
            onChange={(e) => setEquipmentTypeName(e.target.value)}
            type="text"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDialogBoxClose("close")} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleDialogBoxClose("add")} color="primary">
            {dialogBoxActionName}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
